module.exports = __webpack_public_path__ + "img/Buono_pasto_Repas.45a8a18d.jpg";